/** @format */
import {LineProps} from './types';

const GAP = 20; // расстояние от центра круга до основания наконечника стрелки

const isLineProps = (props: unknown): props is LineProps => {
  return (props as LineProps)?.points !== undefined;
};

const CustomLine = (props: unknown) => {
  if (!isLineProps(props) || props.points.length < 2) {
    return null;
  }

  const {points} = props;

  // Находим точки "Факт" и "ИИ" (они должны быть вторая и третья в массиве)
  const factIndex = 1;
  const aiIndex = 2;

  if (points.length <= aiIndex) {
    return null;
  }

  const p1 = points[factIndex]; // Факт
  const p2 = points[aiIndex]; // ИИ

  const dx = p2.x - p1.x;
  const dy = p2.y - p1.y;
  const len = Math.sqrt(dx * dx + dy * dy);

  if (len === 0) return null;

  // единичный вектор направления
  const ux = dx / len;
  const uy = dy / len;

  // размеры стрелки
  const arrowHeight = 15; // высота наконечника стрелки
  const arrowWidth = 12; // ширина основания наконечника

  // начало линии (от точки Факт с отступом)
  const startX = p1.x + ux * GAP;
  const startY = p1.y + uy * GAP;

  // конец линии (до точки ИИ с отступом, учитывая зазор перед стрелкой)
  const lineEndX = p2.x - ux * (GAP + arrowHeight);
  const lineEndY = p2.y - uy * (GAP + arrowHeight);

  // вершина стрелки (прилегает к кружку)
  const arrowTipX = p2.x - ux * GAP;
  const arrowTipY = p2.y - uy * GAP;

  // основание стрелки (с зазором от линии)
  const arrowBaseX = p2.x - ux * (GAP + arrowHeight);
  const arrowBaseY = p2.y - uy * (GAP + arrowHeight);

  // перпендикулярный вектор для основания
  const nx = -uy;
  const ny = ux;

  // точки основания треугольника стрелки
  const baseLeftX = arrowBaseX + nx * (arrowWidth / 2);
  const baseLeftY = arrowBaseY + ny * (arrowWidth / 2);

  const baseRightX = arrowBaseX - nx * (arrowWidth / 2);
  const baseRightY = arrowBaseY - ny * (arrowWidth / 2);

  const gradId = 'arrow-gradient-unique';

  return (
    <g>
      <defs>
        <linearGradient
          id={gradId}
          gradientUnits='userSpaceOnUse'
          x1={startX}
          y1={startY}
          x2={arrowTipX}
          y2={arrowTipY}
        >
          <stop offset='8.87%' stopColor='#B17629' />
          <stop offset='100%' stopColor='#419466' />
        </linearGradient>
      </defs>
      {/* Линия стрелки - от Факта до основания наконечника с зазором */}
      <line
        x1={startX}
        y1={startY}
        x2={lineEndX}
        y2={lineEndY}
        stroke={`url(#${gradId})`}
        strokeWidth={2}
        fill='none'
      />
      {/* Наконечник стрелки - треугольник с зазором от линии */}
      <path
        d={`M${arrowTipX},${arrowTipY} L${baseLeftX},${baseLeftY} L${baseRightX},${baseRightY} Z`}
        fill={`url(#${gradId})`}
      />
    </g>
  );
};

export default CustomLine;

